import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  BankAccount,
  AccountModal,
  AccountListDetails,
  AccountListingQueryParameters,
} from "./type";

export const accountInitialState: AccountModal = {
  accountList: {
    manufacturerId: "",
    accounts: [],
  },

  accountListingQueryParameters: {
    pageNo: 1,
    limit: 10,
    searchText: "",
  },

  accountDetails: {
    name: "",
    status: "",
    userId: "",
    bankName: "",
    accountType: "",
    createdDate: 0,
    isSelected: "",
    bankAccountId: "",
    accountLast4: "",
    externalBankAccountId: "",
  },
};

const AccountSlice = createSlice({
  name: "account",
  initialState: accountInitialState,
  reducers: {
    setAccountListingData: (
      state: AccountModal,
      action: PayloadAction<AccountListDetails>,
    ) => {
      state.accountList = { ...action.payload };
    },

    setAccountListingQueryParameters: (
      state: AccountModal,
      action: PayloadAction<AccountListingQueryParameters>,
    ) => {
      state.accountListingQueryParameters = { ...action.payload };
    },

    setAccountDetails: (
      state: AccountModal,
      action: PayloadAction<BankAccount>,
    ) => {
      state.accountDetails = action.payload;
    },
  },
});

export const {
  setAccountDetails,
  setAccountListingData,
  setAccountListingQueryParameters,
} = AccountSlice.actions;

export default AccountSlice.reducer;
